import { createAction } from '@reduxjs/toolkit';

import { SPEED_TEST_ANIMATION_LOADED } from '../constants/action-types';

export const animationLoaded = createAction(SPEED_TEST_ANIMATION_LOADED);
